import React, { useContext, useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";
import suicide from "../../Assets/Projects/suicide.png";
import bitsOfCode from "../../Assets/Projects/blog.png";
import { amitContext } from "../../context/amit";

function Projects() {
  
  const ref = useRef()
  const {current} = useContext(amitContext)
  useEffect(() => {
    if(current === 'projects')
    ref?.current?.scrollIntoView({})

  }, [current])


  return (
    <Container fluid className="project-section" ref={ref}>
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath="https://cdn.hashnode.com/res/hashnode/image/upload/v1662807607742/ciX7-dmxz.png?auto=compress,format&format=webp"
              isBlog={false}
              title="Prime-Video-Clone"
              description="During our construct week, I was assigned a task to create a pixel-perfect clone of Prime Video website. I was given a team of four excluding me. We started working on it and completed all the given tasks in 4 days."
              techStack="TechStack - JavaScript | CSS | HTML"
              ghLink="https://github.com/amitmishra7488/prime_video_clone"
              demoLink="https://tangerine-beijinho-a4d19c.netlify.app/home/home"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath="https://cdn.hashnode.com/res/hashnode/image/upload/v1666277274051/eGKQ59Nqr.png?auto=compress,format&format=webp"
              isBlog={false}
              title="Best-Buy-Clone"
              description="BestBuy is an online retailer that sells electronic items like Laptop , TV , Mobile-Phones ,etc. On this website, I have built CartPage, Signup, and login, I also handled the sorting and filter part in product page ."
              techStack="TechStack - JavaScript | CSS | HTML | json-server "

              ghLink="https://github.com/amitmishra7488/team_BestBuy"
              demoLink="https://resilient-beignet-11d38c.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath="https://miro.medium.com/max/720/1*tqD_DYwTF-g5EJxentxIXA.webp"
              isBlog={false}
              title="Lenskart-Clone"
              description="LensKart is an online retailer that sells Eyewear and trendy sunglasses, This is a collaborative project. "
              techStack="TechStack - React | JavaScript | CSS | HTML | chakra-UI | json-server "
              ghLink="https://github.com/amitmishra7488/Lenskart-clone"
              demoLink="https://lenskart-clone.netlify.app/"              
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
